export default "__VITE_ASSET__DK6Lxy4G__"